








































































































import Vue from 'vue'
import moment from 'moment'

import {
  GenerateReport,
  DownloadReport,
  CEMSReport,
  Company,
  Stack,
  FindStacks,
} from '@/api/cems'

import { FindTemplates } from '@/api/report'
import { mapGetters } from 'vuex'

interface SelectOption {
  value: number | string
  text: string
}

export default Vue.extend({
  name: 'Report',
  data() {
    return {
      fileURL: '',
      generatingReport: false,
      downloadingReport: false,
      form: {
        date: moment().format('YYYY-MM-D'),
        reportId: 0,
        stackUID: '',
        hour: new Date().getHours() - 1,
        elDatePicker: [0, 0],
        source: 'QAQC',
      },

      optsReport: [] as SelectOption[],

      stacks: [] as Stack[],

      report: {
        fields: [],
        values: [],
        company: {} as Company,
        stack: {} as Stack,
      } as CEMSReport,
    }
  },
  computed: {
    ...mapGetters(['isInstrument']),
  },
  methods: {
    async findTemplate() {
      const tp = await FindTemplates()
      this.optsReport = tp.map((t) => {
        return {
          value: t.id,
          text: t.name,
        }
      })
    },
    async findChimneys() {
      this.stacks = await FindStacks()
    },
    async generateReport(download: boolean) {
      if (this.form.reportId == 0) {
        return
      }

      const start = moment(this.form.elDatePicker[0]).valueOf()
      const end = moment(this.form.elDatePicker[1] - 1).valueOf()

      const pdf = await GenerateReport(
        this.form.source,
        this.form.stackUID,
        this.form.reportId,
        start,
        end,
        download
      )
      if (!download) {
        try {
          JSON.parse(pdf)
          // this.$toast.error(respJSON.data.message)
        } catch {
          this.fileURL = URL.createObjectURL(pdf)
        }
      }
    },

    async downloadReport() {
      if (this.form.reportId == 0) {
        return
      }

      const start = moment(this.form.elDatePicker[0]).valueOf()
      const end = moment(this.form.elDatePicker[1] - 1).valueOf()

      await DownloadReport(
        this.form.source,
        this.form.stackUID,
        this.form.reportId,
        start,
        end
      )
    },

    // -------------------------------------------------------------------------------------------------
    // Handle eventt
    // -------------------------------------------------------------------------------------------------

    async onFormGenerateReport() {
      this.generatingReport = true
      URL.revokeObjectURL(this.fileURL)
      this.fileURL = ''
      try {
        await this.generateReport(false)
      } catch {
        //
      }
      this.generatingReport = false
    },

    async onFormDownloadReport() {
      this.downloadingReport = true
      await this.downloadReport()
      this.downloadingReport = false
    },

    async onPrintReport() {
      window.print()
    },
  },

  async created() {
    // set default picker
    const cDate = moment().format('YYYY-MM-DD')
    this.form.elDatePicker[0] = moment(cDate).valueOf()
    this.form.elDatePicker[1] = this.form.elDatePicker[0] + 86400000

    await this.findTemplate()
    await this.findChimneys()
  },
  beforeDestroy() {
    URL.revokeObjectURL(this.fileURL)
  },
})
